/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';

export const Variant1 = styled.div`
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const Variant2 = styled(Variant1)`
  gap: 4px;
`;

export const Variant3 = styled.div`
  color: ${Palette.PrimaryGray._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const Variant4 = styled(Variant3)`
  gap: 4px;
`;

export const Variant5 = styled.div`
  color: ${Palette.Orange._600};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  gap: 8px;
`;

export const Variant6 = styled(Variant5)`
  color: ${Palette.Red._500};
`;

export const Variant7 = styled(Variant5)`
  color: ${Palette.Green._600};
`;
